/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const createClinicResponseClinicBookings7dMin = 0
export const createClinicResponseClinicBookings7dMax = 9007199254740991

export const createClinicResponseClinicCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const createClinicResponseClinicErrors24hMin = 0
export const createClinicResponseClinicErrors24hMax = 9007199254740991

export const createClinicResponseClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const createClinicResponseClinicPfLastHeartbeatAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const createClinicResponseClinicUsersCountMin = 0
export const createClinicResponseClinicUsersCountMax = 9007199254740991

export const createClinicResponseConnectionTestOneLatencyMsOneMin = 0
export const createClinicResponseConnectionTestOneLatencyMsOneMax = 9007199254740991

export const createClinicResponseConnectionTestOneTestedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const createClinicResponseFirstAdminUserAddedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const createClinicResponseFirstAdminUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const createClinicResponseFirstAdminUserLastActiveAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)

export const CreateClinicResponse = zod.object({
  catalogLoaded: zod.boolean(),
  clinic: zod.object({
    bookings7d: zod.int().min(createClinicResponseClinicBookings7dMin).max(createClinicResponseClinicBookings7dMax),
    connection: zod.enum(['connected', 'not_connected']),
    createdAt: zod.iso.datetime({ offset: true }).regex(createClinicResponseClinicCreatedAtRegExp),
    displayStatus: zod.enum(['active', 'inactive', 'not_connected']),
    errors24h: zod.int().min(createClinicResponseClinicErrors24hMin).max(createClinicResponseClinicErrors24hMax),
    id: zod.uuid().regex(createClinicResponseClinicIdRegExp),
    name: zod.string(),
    needsAttention: zod.boolean(),
    pf: zod.object({
      degradedReason: zod.string().nullable(),
      lastHeartbeatAt: zod.union([
        zod.iso.datetime({ offset: true }).regex(createClinicResponseClinicPfLastHeartbeatAtOneRegExp),
        zod.null(),
      ]),
      pfKeeperApp: zod.enum(['up', 'degraded', 'down', 'unknown']),
      pfSession: zod.enum(['up', 'degraded', 'down', 'unknown']),
      status: zod.enum(['healthy', 'degraded', 'down', 'unknown', 'not_connected', 'inactive']),
    }),
    slug: zod.string(),
    status: zod.enum(['active', 'inactive']),
    testingIgnorePfHours: zod.boolean().optional(),
    usersCount: zod.int().min(createClinicResponseClinicUsersCountMin).max(createClinicResponseClinicUsersCountMax),
  }),
  connectionTest: zod.union([
    zod.object({
      apiReady: zod.boolean(),
      authenticated: zod.boolean(),
      bookingEnabled: zod.boolean().nullable(),
      error: zod.union([
        zod.enum(['timeout', 'connection_refused', 'tls_error', 'unauthorized', 'bad_response', 'pf_not_ready']),
        zod.null(),
      ]),
      keeperVersion: zod.string().nullable(),
      latencyMs: zod.union([
        zod
          .int()
          .min(createClinicResponseConnectionTestOneLatencyMsOneMin)
          .max(createClinicResponseConnectionTestOneLatencyMsOneMax),
        zod.null(),
      ]),
      pfLoggedIn: zod.boolean(),
      pfTimeZone: zod.string().nullable(),
      reachable: zod.boolean(),
      testedAt: zod.iso.datetime({ offset: true }).regex(createClinicResponseConnectionTestOneTestedAtRegExp),
      timeZoneMatches: zod.boolean().nullable(),
    }),
    zod.null(),
  ]),
  firstAdmin: zod.object({
    existingAccount: zod.boolean(),
    temporaryPassword: zod.string().nullable(),
    user: zod.object({
      addedAt: zod.iso.datetime({ offset: true }).regex(createClinicResponseFirstAdminUserAddedAtRegExp),
      email: zod.string(),
      id: zod.uuid().regex(createClinicResponseFirstAdminUserIdRegExp),
      isYou: zod.boolean(),
      lastActiveAt: zod.union([
        zod.iso.datetime({ offset: true }).regex(createClinicResponseFirstAdminUserLastActiveAtOneRegExp),
        zod.null(),
      ]),
      name: zod.string(),
      role: zod.enum(['admin', 'user']),
      status: zod.enum(['must_set_password', 'active']),
    }),
  }),
})

export type CreateClinicResponse = zod.input<typeof CreateClinicResponse>
export type CreateClinicResponseOutput = zod.output<typeof CreateClinicResponse>
